import { React, lazy, useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { TableContext } from '../contexts/tableContext';
import { resolveUserMenus } from '../utils/menuUtils';

const Header = lazy(() => import('../components/Header/Header'));
const Footer = lazy(() => import('../components/Footer/DashFooter'));
const Menu = lazy(() => import('../components/LeftMenu/DashMenu'));

export default function Innerlayout() {
  const { userMenus, setUserMenus } = useContext(TableContext);

  useEffect(() => {
    const savedMenu = resolveUserMenus(userMenus);
    if (savedMenu.length > 0 && userMenus.length === 0) {
      setUserMenus(savedMenu);
    }
  }, [setUserMenus, userMenus.length]);

  return (
    <div>
      <Header />
      <Menu />
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
